import { makeAutoObservable, runInAction } from 'mobx';
import fetchService from '../servises/fetch.service';
import { registerAccountStateReset } from '../servises/account-state.service';

export const normalizeUsageResponse = data => {
    const usage = data || {};
    return {
        range: usage.range || '30d',
        granularity: usage.granularity || 'hour',
        network: usage.network || {
            received: 0,
            transmitted: 0,
            combined: 0
        },
        ssh: usage.ssh || {
            successful: 0,
            failed: 0,
            combined: 0
        },
        points: Array.isArray(usage.points) ? usage.points : [],
        limitations: Array.isArray(usage.limitations) ? usage.limitations : []
    };
};

class UsageStore {
    constructor() {
        makeAutoObservable(this);
    }

    range = '30d';
    loading = false;
    error = '';
    usage = normalizeUsageResponse();
    requestSequence = 0;

    async getUsage(serverId) {
        const requestSequence = ++this.requestSequence;
        const range = this.range;
        runInAction(() => {
            this.loading = true;
            this.error = '';
        });

        try {
            const response = await fetchService.authenticatedGet(
                `/usage/${ serverId }?range=${ range }`);
            const responseData = response && response.data;
            if (!responseData || responseData.isError) {
                throw new Error(responseData ? responseData.message : 'Failed to load usage history');
            }

            runInAction(() => {
                if (requestSequence === this.requestSequence) {
                    this.usage = normalizeUsageResponse(responseData.data_o);
                }
            });
        } catch (error) {
            runInAction(() => {
                if (requestSequence === this.requestSequence) {
                    this.error = error.message || 'Failed to load usage history';
                    this.usage = normalizeUsageResponse({ range: this.range });
                }
            });
        } finally {
            runInAction(() => {
                if (requestSequence === this.requestSequence) {
                    this.loading = false;
                }
            });
        }
    }

    async setRange(range, serverId) {
        runInAction(() => {
            this.range = range;
        });
        await this.getUsage(serverId);
    }

    clear() {
        this.requestSequence += 1;
        this.range = '30d';
        this.loading = false;
        this.error = '';
        this.usage = normalizeUsageResponse();
    }
}

const usageStore = new UsageStore();
registerAccountStateReset(() => usageStore.clear());

export default usageStore;
